import React from 'react';
import { useTheme } from '@emotion/react';
import { type CSSObject } from '@emotion/styled';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';

import './funnel-checkbox.scss';

const checkmark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="11"
    viewBox="0 0 14 11"
  >
    <path
      fill="#FFF"
      d="M9.06764833,13.1413828 L5.89389204,9.98890436 C5.78562148,9.8806338 5.60955304,9.88282178 5.50345786,9.98890436 L4.08120292,11.4199784 C3.97293236,11.528249 3.97293236,11.7043174 4.08120292,11.8125964 C5.68179967,13.4026942 7.2805766,14.992932 8.88117335,16.58079 C8.98944391,16.6890606 9.16551235,16.6890606 9.27379131,16.58079 L17.9207094,7.89397603 C18.026792,7.78570547 18.026792,7.60963703 17.9185221,7.50135807 L16.4874481,6.08120292 C16.3791775,5.97293236 16.2031091,5.97293236 16.0948301,6.08120292 L9.06824677,13.1422227 L9.06764833,13.1413828 Z"
      transform="translate(-4 -6)"
    />
  </svg>
);

type Props = {
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  label: React.ReactNode;
  checked: boolean;
  classes?: string;
  name: string;
  wrapperStyles?: CSSObject;
  modal?: boolean;
  hide_checkbox?: boolean;
};

const FunnelCheckbox: React.FC<Props> = ({
  name,
  handleChange,
  checked,
  label = '',
  classes = '',
  wrapperStyles,
  modal,
  hide_checkbox,
}) => {
  const theme = useTheme() as EmotionTheme;

  const borderColor =
    (modal
      ? theme.modalTitleFontColor || theme.modalTextColor || theme.primaryColor
      : theme.primaryColor) || 'inherit';
  const textColor =
    (modal ? theme.modalTextColor || theme.textColor : theme.textColor) ||
    'inherti';
  const indicatorStyles = checked
    ? {
        background: 'none',
        border: `2px solid ${borderColor}`,
        color: borderColor,
      }
    : {
        border: `2px solid ${textColor}`,
        background: 'none',
        opacity: 0.4,
      };

  return (
    <div className="bbk-funnel-checkbox-wrapper" css={wrapperStyles}>
      <label
        className={cs('bbk-funnel-checkbox-label', classes)}
        htmlFor={name}
        style={{
          color: textColor,
        }}
      >
        {!hide_checkbox && (
          <>
            <input
              type="checkbox"
              className="bbk-funnel-checkbox-input"
              id={name}
              name={name}
              onChange={handleChange}
              checked={checked}
            />
            <div
              className="bbk-funnel-checkbox-indicator"
              style={indicatorStyles}
            >
              {checkmark}
            </div>
          </>
        )}
        <span>
          <CustomerHtml value={label} />
        </span>
      </label>
    </div>
  );
};

export default FunnelCheckbox;
